module.exports = __webpack_public_path__ + "static/img/2.6c4bb43.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/eng/2.png
// module id = oi3S
// module chunks = 0